"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INSTRUMENT_STATUSES = exports.FLUID_LINE_STATES = exports.CARTRIDGE_FLUID_LEVELS = void 0;

var _luxon = require("luxon");

var _ = require(".");

var FLUID_LINE_STATES = {
  FLUID_UNKNOWN: 'FLUID_UNKNOWN',
  FLUID_DISCONNECTED: 'FLUID_DISCONNECTED',
  FLUID_PRESENT: 'FLUID_PRESENT',
  FLUID_NOT_PRESENT: 'FLUID_NOT_PRESENT'
};
exports.FLUID_LINE_STATES = FLUID_LINE_STATES;
var CARTRIDGE_FLUID_LEVELS = {
  CARTRIDGE_FLUID_LEVEL_UNKNOWN: 'CARTRIDGE_FLUID_LEVEL_UNKNOWN',
  CARTRIDGE_FLUID_LEVEL_LOW: 'CARTRIDGE_FLUID_LEVEL_LOW',
  CARTRIDGE_FLUID_LEVEL_GOOD: 'CARTRIDGE_FLUID_LEVEL_GOOD',
  CARTRIDGE_UNINSTALLED: 'CARTRIDGE_UNINSTALLED'
};
exports.CARTRIDGE_FLUID_LEVELS = CARTRIDGE_FLUID_LEVELS;
var INSTRUMENT_STATUSES = {
  ACTIVE: 1,
  INACTIVE: 2,
  EXPIRED: 3,
  DELETED: 4
};
exports.INSTRUMENT_STATUSES = INSTRUMENT_STATUSES;

var Instrument =
/** @class */
function () {
  function Instrument() {
    this.serialNumber = null;
    this.isSuspended = null;
    this.isBusy = null;
    this.lastSeenTimestamp = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.practiceId = null;
    this.practice = null;
    this.tests = null;
    this.friendlyName = null;
    this.testsSinceLastChangeLine1 = null;
    this.testsSinceLastChangeLine2 = null;
    this.testsSinceLastChangeLine3 = null;
    this.testsSinceLastChangeLine4 = null;
    this.testsSinceLastChangeLine5 = null;
    this.testsSinceLastChangeLine6 = null;
    this.statusId = null;
    this.ignoreCartridgeSensors = null;
    this.ignoreCartridgeReadySensors = null;
  }

  Instrument.thaw = function (instrumentObj) {
    var _a, _b, _c;

    if (instrumentObj == null) return null;
    var instrument = new Instrument();

    if (instrumentObj.serialNumber != null) {
      instrument.setSerialNumber(instrumentObj.serialNumber);
    }

    if (instrumentObj.friendlyName != null) {
      instrument.setFriendlyName(instrumentObj.friendlyName);
    }

    if (instrumentObj.isSuspended != null) {
      instrument.setIsSuspended(instrumentObj.isSuspended == null ? null : instrumentObj.isSuspended ? true : false);
    }

    if (instrumentObj.isBusy != null) {
      instrument.setIsBusy(instrumentObj.isBusy == null ? null : instrumentObj.isBusy ? true : false);
    }

    if (instrumentObj.lastSeenTimestamp != null) {
      instrument.setLastSeenTimestamp((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(instrumentObj.lastSeenTimestamp)) !== null && _a !== void 0 ? _a : null);
    }

    if (instrumentObj.createdAt != null) {
      instrument.setCreatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(instrumentObj.createdAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (instrumentObj.updatedAt != null) {
      instrument.setUpdatedAt((_c = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(instrumentObj.updatedAt)) !== null && _c !== void 0 ? _c : null);
    }

    if (instrumentObj.practiceId != null) {
      instrument.setPracticeId(instrumentObj.practiceId);
    }

    if (instrumentObj.practice != null) {
      instrument.setPractice(_.Practice.thaw(instrumentObj.practice));
    }

    if (instrumentObj.tests != null) {
      instrument.setTests(_.Test.thawList(instrumentObj.tests));
    }

    if (instrumentObj.testsSinceLastChangeLine1 != null) {
      instrument.setTestsSinceLastChangeLine1(instrumentObj.testsSinceLastChangeLine1);
    }

    if (instrumentObj.testsSinceLastChangeLine2 != null) {
      instrument.setTestsSinceLastChangeLine2(instrumentObj.testsSinceLastChangeLine2);
    }

    if (instrumentObj.testsSinceLastChangeLine3 != null) {
      instrument.setTestsSinceLastChangeLine3(instrumentObj.testsSinceLastChangeLine3);
    }

    if (instrumentObj.testsSinceLastChangeLine4 != null) {
      instrument.setTestsSinceLastChangeLine4(instrumentObj.testsSinceLastChangeLine4);
    }

    if (instrumentObj.testsSinceLastChangeLine5 != null) {
      instrument.setTestsSinceLastChangeLine5(instrumentObj.testsSinceLastChangeLine5);
    }

    if (instrumentObj.testsSinceLastChangeLine6 != null) {
      instrument.setTestsSinceLastChangeLine6(instrumentObj.testsSinceLastChangeLine6);
    }

    if (instrumentObj.statusId != null) {
      instrument.setStatusId(instrumentObj.statusId);
    }

    if (instrumentObj.ignoreCartridgeSensors != null) {
      instrument.setIgnoreCartridgeSensors(instrumentObj.ignoreCartridgeSensors == null ? null : instrumentObj.ignoreCartridgeSensors ? true : false);
    }

    if (instrumentObj.ignoreCartridgeReadySensors != null) {
      instrument.setIgnoreCartridgeReadySensors(instrumentObj.ignoreCartridgeReadySensors == null ? null : instrumentObj.ignoreCartridgeReadySensors ? true : false);
    }

    return instrument;
  };

  Instrument.thawList = function (instrumentObjList) {
    if (instrumentObjList == null) {
      return [];
    }

    var instruments = [];

    for (var i = 0; i < instrumentObjList.length; i++) {
      instruments.push(Instrument.thaw(instrumentObjList[i]));
    }

    return instruments;
  };

  Instrument.freeze = function (instrument) {
    var _a, _b, _c, _d, _e, _f;

    if (instrument == null) {
      return null;
    }

    var instrumentObj = {};

    if (instrument.getSerialNumber() != null) {
      instrumentObj.serialNumber = instrument.getSerialNumber();
    }

    if (instrument.getFriendlyName() != null) {
      instrumentObj.friendlyName = instrument.getFriendlyName();
    }

    if (instrument.getIsSuspended() != null) {
      instrumentObj.isSuspended = instrument.getIsSuspended() == null ? null : instrument.getIsSuspended() ? 1 : 0;
    }

    if (instrument.getIsBusy() != null) {
      instrumentObj.isBusy = instrument.getIsBusy() == null ? null : instrument.getIsBusy() ? 1 : 0;
    }

    if (instrument.getLastSeenTimestamp() != null) {
      instrumentObj.lastSeenTimestamp = (_b = (_a = instrument.getLastSeenTimestamp()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (instrument.getCreatedAt() != null) {
      instrumentObj.createdAt = (_d = (_c = instrument.getCreatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (instrument.getUpdatedAt() != null) {
      instrumentObj.updatedAt = (_f = (_e = instrument.getUpdatedAt()) === null || _e === void 0 ? void 0 : _e.toISO()) !== null && _f !== void 0 ? _f : null;
    }

    if (instrument.getPracticeId() != null) {
      instrumentObj.practiceId = instrument.getPracticeId();
    }

    if (instrument.getPractice() != null) {
      instrumentObj.practice = _.Practice.freeze(instrument.getPractice());
    }

    if (instrument.getTests() != null) {
      instrumentObj.tests = _.Test.freezeList(instrument.getTests());
    }

    if (instrument.getTestsSinceLastChangeLine1() != null) {
      instrumentObj.testsSinceLastChangeLine1 = instrument.getTestsSinceLastChangeLine1();
    }

    if (instrument.getTestsSinceLastChangeLine2() != null) {
      instrumentObj.testsSinceLastChangeLine2 = instrument.getTestsSinceLastChangeLine2();
    }

    if (instrument.getTestsSinceLastChangeLine3() != null) {
      instrumentObj.testsSinceLastChangeLine3 = instrument.getTestsSinceLastChangeLine3();
    }

    if (instrument.getTestsSinceLastChangeLine4() != null) {
      instrumentObj.testsSinceLastChangeLine4 = instrument.getTestsSinceLastChangeLine4();
    }

    if (instrument.getTestsSinceLastChangeLine5() != null) {
      instrumentObj.testsSinceLastChangeLine5 = instrument.getTestsSinceLastChangeLine5();
    }

    if (instrument.getTestsSinceLastChangeLine6() != null) {
      instrumentObj.testsSinceLastChangeLine6 = instrument.getTestsSinceLastChangeLine6();
    }

    if (instrument.getStatusId() != null) {
      instrumentObj.statusId = instrument.getStatusId();
    }

    if (instrument.getIgnoreCartridgeSensors() != null) {
      instrumentObj.ignoreCartridgeSensors = instrument.getIgnoreCartridgeSensors() == null ? null : instrument.getIgnoreCartridgeSensors() ? 1 : 0;
    }

    if (instrument.getIgnoreCartridgeReadySensors() != null) {
      instrumentObj.ignoreCartridgeReadySensors = instrument.getIgnoreCartridgeReadySensors() == null ? null : instrument.getIgnoreCartridgeReadySensors() ? 1 : 0;
    }

    return instrumentObj;
  };

  Instrument.freezeList = function (instruments) {
    if (instruments == null) {
      return [];
    }

    var instrumentObjList = [];

    for (var i = 0; i < instruments.length; i++) {
      instrumentObjList.push(Instrument.freeze(instruments[i]));
    }

    return instrumentObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Instrument.prototype.setSerialNumber = function (serialNumber) {
    this.serialNumber = serialNumber;
  };

  Instrument.prototype.setFriendlyName = function (friendlyName) {
    this.friendlyName = friendlyName;
  };

  Instrument.prototype.setIsSuspended = function (isSuspended) {
    this.isSuspended = isSuspended;
  };

  Instrument.prototype.setIsBusy = function (isBusy) {
    this.isBusy = isBusy;
  };

  Instrument.prototype.setLastSeenTimestamp = function (lastSeenTimestamp) {
    this.lastSeenTimestamp = lastSeenTimestamp;
  };

  Instrument.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Instrument.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  Instrument.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  Instrument.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  Instrument.prototype.setTests = function (tests) {
    this.tests = tests;
  };

  Instrument.prototype.setTestsSinceLastChangeLine1 = function (testsSinceLastChangeLine1) {
    this.testsSinceLastChangeLine1 = testsSinceLastChangeLine1;
  };

  Instrument.prototype.setTestsSinceLastChangeLine2 = function (testsSinceLastChangeLine2) {
    this.testsSinceLastChangeLine2 = testsSinceLastChangeLine2;
  };

  Instrument.prototype.setTestsSinceLastChangeLine3 = function (testsSinceLastChangeLine3) {
    this.testsSinceLastChangeLine3 = testsSinceLastChangeLine3;
  };

  Instrument.prototype.setTestsSinceLastChangeLine4 = function (testsSinceLastChangeLine4) {
    this.testsSinceLastChangeLine4 = testsSinceLastChangeLine4;
  };

  Instrument.prototype.setTestsSinceLastChangeLine5 = function (testsSinceLastChangeLine5) {
    this.testsSinceLastChangeLine5 = testsSinceLastChangeLine5;
  };

  Instrument.prototype.setTestsSinceLastChangeLine6 = function (testsSinceLastChangeLine6) {
    this.testsSinceLastChangeLine6 = testsSinceLastChangeLine6;
  };

  Instrument.prototype.setStatusId = function (statusId) {
    this.statusId = statusId;
  };

  Instrument.prototype.setIgnoreCartridgeSensors = function (ignoreCartridgeSensors) {
    this.ignoreCartridgeSensors = ignoreCartridgeSensors;
  };

  Instrument.prototype.setIgnoreCartridgeReadySensors = function (ignoreCartridgeReadySensors) {
    this.ignoreCartridgeReadySensors = ignoreCartridgeReadySensors;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Instrument.prototype.getSerialNumber = function () {
    return this.serialNumber;
  };

  Instrument.prototype.getFriendlyName = function () {
    return this.friendlyName;
  };

  Instrument.prototype.getIsSuspended = function () {
    return this.isSuspended;
  };

  Instrument.prototype.getIsBusy = function () {
    return this.isBusy;
  };

  Instrument.prototype.getLastSeenTimestamp = function () {
    return this.lastSeenTimestamp;
  };

  Instrument.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Instrument.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  Instrument.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  Instrument.prototype.getPractice = function () {
    return this.practice;
  };

  Instrument.prototype.getTests = function () {
    return this.tests;
  };

  Instrument.prototype.getTestsSinceLastChangeLine1 = function () {
    return this.testsSinceLastChangeLine1;
  };

  Instrument.prototype.getTestsSinceLastChangeLine2 = function () {
    return this.testsSinceLastChangeLine2;
  };

  Instrument.prototype.getTestsSinceLastChangeLine3 = function () {
    return this.testsSinceLastChangeLine3;
  };

  Instrument.prototype.getTestsSinceLastChangeLine4 = function () {
    return this.testsSinceLastChangeLine4;
  };

  Instrument.prototype.getTestsSinceLastChangeLine5 = function () {
    return this.testsSinceLastChangeLine5;
  };

  Instrument.prototype.getTestsSinceLastChangeLine6 = function () {
    return this.testsSinceLastChangeLine6;
  };

  Instrument.prototype.getStatusId = function () {
    return this.statusId;
  };

  Instrument.prototype.getIgnoreCartridgeSensors = function () {
    return this.ignoreCartridgeSensors;
  };

  Instrument.prototype.getIgnoreCartridgeReadySensors = function () {
    return this.ignoreCartridgeReadySensors;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  Instrument.prototype.getStatus = function () {
    if (this.statusId == null) return null;

    for (var _i = 0, _a = Object.entries(INSTRUMENT_STATUSES); _i < _a.length; _i++) {
      var _b = _a[_i],
          key = _b[0],
          value = _b[1];
      if (value === this.statusId) return key;
    }

    return null;
  };

  return Instrument;
}();

var _default = Instrument;
exports.default = _default;